export const DESKTOP_ANIMATION_PARAMS = { top: -100, right: -150, scale: 0 };
export const MOBILE_ANIMATION_PARAMS = { top: 800, scale: 0.4, opacity: 0.5 };
